
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./citrus-react.cjs.production.min.js')
} else {
  module.exports = require('./citrus-react.cjs.development.js')
}
